// extracted by mini-css-extract-plugin
module.exports = {"divider":"Divider_divider__3utla","divider__image":"Divider_divider__image__3Ky1n","ellipse":"Divider_ellipse__2l1Dk"};